import type {
    MessageStandardType,
    MessageStandardsClientInterface,
    TargetMappingType,
    UpdateTargetsRequest,
    UpdateTargetsResponse,
} from './messageStandardsClient.types';
import type { CursorPaginationResponse } from '~/services/api';
import type { AxiosPromise } from 'axios';
import BaseClient from '../BaseClient';
import type { CursorPaginationParams } from '../BaseClient.types';

export default class CorporateMessageStandardsClient extends BaseClient implements MessageStandardsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getMessageStandards(params?: CursorPaginationParams): AxiosPromise<CursorPaginationResponse<MessageStandardType>> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getMessageStandard(messageStandardId: number): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createMessageStandard(data: MessageStandardType): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateMessageStandard(messageStandardId: number, data: MessageStandardType): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteMessageStandard(messageStandardId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getDefaultMessageStandard(): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/default-message-standard`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateDefaultMessageStandard(data: MessageStandardType): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/default-message-standard`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    getMessageStandardsTargetCounts(params: { custom_message_standard_ids: number[] }) {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/target-counts`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    getTargetMappings(): AxiosPromise<{ data: TargetMappingType[] }> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/target-mappings`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateTargets(messageStandardId: number, data: UpdateTargetsRequest): AxiosPromise<UpdateTargetsResponse> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}/targets`;
        return this.makeCoreApiRequest(url, 'put', data);
    }
}
